import React from 'react'
import { PlainDocContainer } from './page-content/docs/plain-doc-container'

export const PolicyTosContainer = ({ title, content }) => {
  return (
    <PlainDocContainer>
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </PlainDocContainer>
  )
}
